const NO_PROTOCOL = /^http(.*)$/;

/**
 * Generates a key based on path and file name
 * @param {string} src
 * @returns {string}
 */
export default function generateKey(src) {
    let _src = src;

    if (!NO_PROTOCOL.test(_src)) {
        _src = location.protocol + _src;
    }

    const url = new URL(_src);
    const filename = url.pathname.split("/").slice(-1)[0];

    return `${ url.host }:${ filename }`;
}
